import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/75_card_back_panda_leaves/75_card_back_panda_leaves"
 * Contains 1 texture(s)
 */
export class CardsBacks75CardBackPandaLeavesAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/75_card_back_panda_leaves/75_card_back_panda_leaves';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '75_panda_leaves.png'
    ] as const;
}
